<script>
  import AboutStatCard from '../components/AboutStatCard.svelte';
  import Button from '../components/Button.svelte';
  import { aboutSection } from './about.js';
</script>

<section id="about" class="about-section" aria-labelledby="about-title">
  <div class="about-inner">
    <div class="about-copy">
      <p class="about-kicker">{aboutSection.kicker}</p>

      <div class="about-main">
        <div class="about-heading-group">
          <h2 id="about-title">
            <span class="title-desktop">
              {#each aboutSection.titleLines as line}
                <span>{line}</span>
              {/each}
            </span>
            <span class="title-tablet">{aboutSection.titleTablet}</span>
          </h2>

          <div class="about-line" aria-hidden="true"></div>

          <p class="about-description">
            {#each aboutSection.description as part}
              <span class:accent={part.accent}>{part.text}</span>
            {/each}
          </p>
        </div>

        {#if aboutSection.action}
          <Button href={aboutSection.action.href} label={aboutSection.action.label} variant="light" />
        {/if}
      </div>
    </div>

    <div class="about-stats" aria-label="Ключевые показатели форума">
      {#each aboutSection.stats as stat}
        <AboutStatCard {...stat} />
      {/each}
    </div>
  </div>
</section>

<style>
  .about-section {
    display: flex;
    justify-content: center;
    padding: 60px 0 100px;
    background: #000000;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .about-inner {
    display: flex;
    width: min(100%, 1440px);
    align-items: center;
    justify-content: center;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .about-copy {
    display: flex;
    flex: 1 0 0;
    min-width: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 48px;
    padding: 0 12px;
  }

  .about-kicker {
    width: 239px;
    margin: 0;
    font-size: 24px;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
  }

  .about-main,
  .about-heading-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .about-main {
    gap: 36px;
    width: 100%;
  }

  .about-heading-group {
    gap: 21px;
  }

  h2 {
    margin: 0;
    font-size: 56px;
    font-weight: 700;
    line-height: 56px;
  }

  .title-desktop,
  .title-desktop span {
    display: block;
  }

  .title-tablet {
    display: none;
  }

  .about-line {
    width: 78px;
    height: 4px;
    background: #e7b962;
  }

  .about-description {
    max-width: 585px;
    margin: 14px 0 0;
    color: #ffffff;
    font-size: 32px;
    font-weight: 400;
    line-height: 1.6;
  }

  .accent {
    color: #e7b962;
  }

  .about-stats {
    display: grid;
    flex: 1 0 0;
    min-width: 0;
    grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr);
    align-items: center;
    justify-items: stretch;
    padding: 0 24px;
  }

  .about-stats :global(.about-stat-card:nth-of-type(1)) {
    grid-column: 1;
    grid-row: 1;
  }

  .about-stats :global(.about-stat-card:nth-of-type(2)) {
    grid-column: 3;
    grid-row: 1;
  }

  .about-stats :global(.about-stat-card:nth-of-type(3)) {
    grid-column: 1;
    grid-row: 3;
  }

  .about-stats :global(.about-stat-card:nth-of-type(4)) {
    grid-column: 3;
    grid-row: 3;
  }

  .stat-divider {
    display: block;
    background: rgba(255, 255, 255, 0.5);
  }

  .stat-divider-vertical {
    grid-column: 2;
    width: 1px;
    height: 70px;
    justify-self: center;
  }

  .divider-0 {
    grid-row: 1;
  }

  .divider-2 {
    grid-row: 3;
  }

  .stat-divider-horizontal {
    grid-column: 1 / 4;
    grid-row: 2;
    width: 70px;
    height: 1px;
    justify-self: center;
  }

  @media (max-width: 1279px) {
    .about-section {
      padding: 100px 0 40px;
    }

    .about-inner {
      flex-direction: column;
      gap: 48px;
      padding: 0 32px;
    }

    .about-copy {
      width: 100%;
      align-items: center;
      gap: 48px;
      padding: 0 12px;
      text-align: center;
      box-sizing: border-box;
    }

    .about-kicker,
    .about-main,
    .about-heading-group {
      width: 100%;
      align-items: center;
    }

    h2 {
      max-width: 960px;
      font-size: 40px;
      line-height: 1.1;
    }

    .title-desktop {
      display: none;
    }

    .title-tablet {
      display: block;
    }

    .about-description {
      max-width: 900px;
      margin-top: 14px;
      font-size: 24px;
      text-align: center;
    }

    .about-stats {
      width: 100%;
      padding: 0 24px;
      box-sizing: border-box;
    }
  }

  @media (max-width: 767px) {
    .about-section {
      padding: 40px 0;
    }

    .about-inner {
      gap: 48px;
      padding: 0 24px;
    }

    .about-copy {
      align-items: stretch;
      padding: 0;
      text-align: left;
    }

    .about-kicker {
      text-align: center;
    }

    .about-main,
    .about-heading-group {
      align-items: flex-start;
    }

    h2 {
      font-size: 32px;
      line-height: 32px;
    }

    .title-desktop {
      display: block;
    }

    .title-tablet {
      display: none;
    }

    .about-line {
      align-self: center;
    }

    .about-description {
      max-width: 100%;
      font-size: 16px;
      text-align: left;
    }

    .about-main :global(.button) {
      width: 100%;
    }

    .about-stats {
      padding: 0;
    }

    .stat-divider-vertical {
      display: none;
    }
  }

  @media (max-width: 1599px) and (min-width: 1280px) {
    h2 {
      font-size: 48px;
      line-height: 1.1;
    }
  }
</style>
